export const money = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export const FEE_STATUS_META = {
  pending: { label: "Pending", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  invoiced: { label: "Invoiced", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

// Who actually paid the money out.
export const FEE_PAID_BY_META = {
  client: { label: "Client paid", short: "Client", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  twp: { label: "TWP paid", short: "TWP", cls: "bg-violet-100 text-violet-800 border-violet-200" },
};

export const EMPTY_FEE = {
  label: "", amount: "", status: "pending", due_date: "", note: "", gst: false,
  invoice_number: "", paid_by: "", invoiced_to_type: "", invoiced_to_name: "",
  payment_method: "", payment_reference: "",
  reimbursable: false, reimbursed: false, reimbursed_date: "",
  attachments: [],
};

export const feeTotal = (f) => (f.amount || 0) + (f.gst ? (f.amount || 0) * 0.1 : 0);

// Build the "invoiced to" dropdown options using the project's client/builder names.
export const invoiceTargetOptions = (project = {}) => [
  { value: "client", label: project.client ? `Client · ${project.client}` : "Client" },
  { value: "builder", label: project.builder ? `Builder · ${project.builder}` : "Builder" },
  { value: "custom", label: "Someone else…" },
];

// Resolve a human label for a fee's "invoiced to" (used in the project fees list).
export const invoicedToLabel = (f, project = {}) => {
  if (f.invoiced_to_type === "client") return (project.client || "").trim() || "Client";
  if (f.invoiced_to_type === "builder") return (project.builder || "").trim() || "Builder";
  if (f.invoiced_to_type === "custom") return (f.invoiced_to_name || "").trim() || "Other";
  return null;
};

// Reimbursement badge for TWP-paid fees that are recoverable from the client.
export const reimbursementBadge = (f) => {
  if (f.paid_by !== "twp" || !f.reimbursable) return null;
  if (f.reimbursed) return { label: "Reimbursed", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" };
  return { label: "Recoverable", cls: "bg-amber-100 text-amber-800 border-amber-200" };
};

// Payload shared by create + edit, so both stay in sync.
export const feePayload = (f) => ({
  label: (f.label || "").trim(),
  amount: Number(f.amount),
  status: f.status,
  due_date: f.due_date || null,
  note: f.note || "",
  gst: !!f.gst,
  invoice_number: f.invoice_number || "",
  paid_by: f.paid_by || "",
  invoiced_to_type: f.invoiced_to_type || "",
  invoiced_to_name: f.invoiced_to_type === "custom" ? (f.invoiced_to_name || "") : "",
  payment_method: f.payment_method || "",
  payment_reference: f.payment_reference || "",
  reimbursable: f.paid_by === "twp" ? !!f.reimbursable : false,
  reimbursed: f.paid_by === "twp" && f.reimbursable ? !!f.reimbursed : false,
  reimbursed_date: f.reimbursed_date || null,
  attachments: (f.attachments || []).map((a) => ({
    file_id: a.file_id, storage_path: a.storage_path,
    original_filename: a.original_filename || "", content_type: a.content_type || null,
    size: a.size || null, label: a.label || "",
  })),
});
